
/**
 * 全局配置对象
 */
module.exports = {
	
	// appDebug的命名空间
	appDebugNameSpace : "tellhowdm_debug"
		
}


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/support/conf.js
// module id = 14
// module chunks = 0